// extracted by mini-css-extract-plugin
export default {"wrapper":"app-module--wrapper--3dd29"};